export default __webpack_public_path__ + "7b0ac3cc079414638ae50e334a69dffa.svg";